import { useLingui } from '@lingui/react/macro';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import history from 'modules/overlay-canvas/addons/history';
import UDText from 'ud-ui/components/text';
import { selectFabricManager } from 'modules/template-editor/store/editor/selectors';
import Selector from 'modules/template-editor/ui/components/elements/selector';

interface IProps {
  onChange: (playerIndex: 0 | 1) => void;
  value: 0 | 1;
}

function ChoosingPlayer(props: IProps) {
  const { t } = useLingui();
  const options = [
    { label: t`Игрок №1`, value: 0 },
    { label: t`Игрок №2`, value: 1 },
  ];
  const { onChange, value } = props;
  const manager = useSelector(selectFabricManager);

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>{t`Игрок`}</UDText>
      <Selector
        onFocus={onFocusField}
        styledEachOption
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingPlayer;
